import { DatePipe } from '@angular/common';
import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { DndDropEvent } from 'ngx-drag-drop';
import { HaloLoaderService } from 'src/app/core/halo-loader/halo-loader.service';
import { HaloModalSize } from 'src/app/core/halo-modal/halo-modal-interface';
import { HaloModalService } from 'src/app/core/halo-modal/halo-modal.service';
import { CommonUtil } from 'src/app/core/Utils/common-util';
import { AnnouncementService } from '../../services/announcement.service';
import { PageTitleService } from '../../services/page-title.service';
import { announcementObject,announcementDetailsListObject } from '../../services/announcement.model';
import { HaloToastService,EToastType } from 'src/app/core/halo-toast/halo-toast.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { SelectionInfo } from '../../selectors/multi-selection/multi-selection.model';

@Component({
  selector: 'app-announcement',
  templateUrl: './announcement.component.html',
  styleUrls: ['./announcement.component.scss', 
  '.dragIcon { height: 14px; width: 14px; float: right; margin-right: 5px;background: url("'+`${environment.haloWebCloudBasePath}`+'/git/Icons/ico_drag_blue.png") no-repeat; }',
  '.dragIcon.active{background: url("'+`${environment.haloWebCloudBasePath}`+'/git/Icons/ico_drag_gray.png") no-repeat;}'] 
})
export class AnnouncementComponent implements OnInit, OnDestroy {
  private originalAnnouncementsList: announcementObject[]; 
  private announcementsList: announcementObject[];
  private stopSlideshow = true;

  private setId: string;
  private hasEditPermission = false;
  private showDeleteMsg = false;
  private hasNewItem = false;
  private selectionInfo: SelectionInfo;
  private forDeleleteItem: announcementObject | any;

  private saveAsError = false;
  private saveAsName = '';
  private saveAsLabel = '';
  private saveAsAnnouncementObj:any;
  private showPreviewScreenLabel = '';
  private previewScreenAnnouncementDetailsList: announcementDetailsListObject[];
  haloWebCloudURL:string = environment.haloWebCloudBasePath;
  deleteModalProps = {
    title: this.commonUtil.replaceValueAsHTMLOnTranslatedText('DELETE.NO', [this.commonUtil.translateText('ANNOUNCEMENT')]),
    message: '',
    isWarningPopup: true,
    ctaButtonLabel: 'DELETE',
    negativeButtonLabel: 'CANCEL',
    isCloseIconCallsCta: false,
    isSecondaryTextButton: true,
    hideSecondaryButton: false,
  };

  @ViewChild('actionTemplate') actionTemplate: TemplateRef<any>;
  @ViewChild('bodyTemplate') bodyTemplate: TemplateRef<any>;
  @ViewChild('previewScreenbodyTemplate') previewScreenbodyTemplate: TemplateRef<any>;
  
  constructor(
    private router: Router,
    private modal: HaloModalService,
    private pageTitleService: PageTitleService,
    private commonUtil: CommonUtil,
    private loader: HaloLoaderService,
    private announcementServ: AnnouncementService,
    private toast: HaloToastService) {
    }

  ngOnInit(): void {
    this.pageTitleService.setTitle('');
  }
 
  ngOnDestroy(): void {
    this.stopSlideshow = true;
  }

  onToggleCollapse(event: any, setId: string) {
    this.setId = setId;    
    var expanded = event.target.getAttribute('aria-expanded');
    if(expanded === 'true'){
      this.setId = '';
    }
  }

  private async getData() {
    this.hasEditPermission = this.selectionInfo.facility.summary?.isLoggedInManagerAdmin === 'true' ||
      this.selectionInfo.facility.summary?.userRights.customize === 'F';
    try {
      this.loader.startProcess();
      let facilityIdList= this.selectionInfo.facility.facilityId.split(',');
      let data = {facilityIds:facilityIdList,consoleType:this.selectionInfo.consoleType};
      let resp:any = await this.announcementServ.getAnnouncements(data); 
      this.originalAnnouncementsList = resp; 
      this.announcementsList =  JSON.parse(JSON.stringify(this.originalAnnouncementsList));  
    } catch (error) {
      console.error("API error.")
    }
    finally {
      this.loader.endProcess();
    }
  }

  processDelete(announcement: any) {
    this.forDeleleteItem = announcement;
    this.showDeleteMsg = true;
    if(announcement.inUse){
      this.deleteModalProps.message = this.commonUtil.replaceValueAsHTMLOnTranslatedText('DELETE.PUBLISHED.MODAL.MESSAGE', [this.commonUtil.translateText('ANNOUNCEMENT')]);
    }else{
      this.deleteModalProps.message = this.commonUtil.replaceValueAsHTMLOnTranslatedText('DELETE.MODAL.MESSAGE', [this.commonUtil.translateText('ANNOUNCEMENT')]);
    }
  }

  async confirmDelete() {
    if(this.forDeleleteItem && this.forDeleleteItem.id !== '-1'){
      try {
        this.loader.startProcess();
        await this.announcementServ.deleteAnnouncement(this.forDeleleteItem.id, this.forDeleleteItem.consoleType);
        this.toast.creatToast(
          this.commonUtil.replaceValueAsHTMLOnTranslatedText('DELETED.SUCCESS.MSG', [this.forDeleleteItem.name]),
          EToastType.SUCCESS
        );
        this.getData();
        this.selectionInfo.rootScopeData.isPageHasUnsavedChanges = true;
      } catch (error) {  
        console.error('API error.');
      }
      finally {
        this.loader.endProcess();
        this.resetStatus();
      }
    }else{
      this.loader.startProcess();
      this.getData();
      this.loader.endProcess();
      this.resetStatus();
    }
  }

  resetStatus(){
    this.forDeleleteItem = null;
    this.showDeleteMsg = false;
    this.hasNewItem = false;
    this.selectionInfo.rootScopeData.isPageHasUnsavedChanges = false;
  }

  onDrop(event: DndDropEvent, index: number,announcement: announcementObject, list: announcementDetailsListObject[]) {
    if( list && (event.dropEffect === "move") ) {
      let checkOrderChanges = true;
      let srcIdx = list.findIndex(i => i.id === event.data.id);
      if(list[srcIdx].title.trim() === '' && list[index].title.trim() === '' && list[srcIdx].message.trim() === '' && list[index].message.trim() === ''){
        checkOrderChanges = false;
      }else{
        let destItem = list[index];
        // Below are the inserting drogdrop position
        list.splice(srcIdx, 1); // Removed current drag value.
        list.splice( index, 0, event.data ) // Insert current drag value into drop place.

        // Below are the switching dragdrop position.
        // list[srcIdx] = destItem;
        // list[index] = event.data;
      }
     
      if(checkOrderChanges){
        announcement.hasDisplayedOrderChanged = this.checkedAnnouncementDisplayOrderChanged(announcement.id);
        this.announcementsList.filter(val => val.id ===  announcement.id).map(val => val.isEdited = announcement.hasDisplayedOrderChanged?announcement.hasDisplayedOrderChanged:false);
      } 
      
      this.selectionInfo.rootScopeData.isPageHasUnsavedChanges = true;
    }
  }
  addNew() {
    if(this.hasNewItem){
      return;
    }
    var datePipe = new DatePipe('en-US');
    let defaultNewAnnouncement = {
      announcementDetailsList:[
      {"id":"1","message":"","title":"","displayOrder":1},
      {"id":"2","message":"","title":"","displayOrder":2},
      {"id":"3","message":"","title":"","displayOrder":3},
      {"id":"4","message":"","title":"","displayOrder":4},
      {"id":"5","message":"","title":"","displayOrder":5},
      {"id":"6","message":"","title":"","displayOrder":6},
      {"id":"7","message":"","title":"","displayOrder":7},
      {"id":"8","message":"","title":"","displayOrder":8},
      {"id":"9","message":"","title":"","displayOrder":9},
      {"id":"10","message":"","title":"","displayOrder":10}],
      id:"-1",
      duration:'120.0',
      hasAnnouncementChanged:false,
      hasDisplayedOrderChanged:false,
      consoleType:this.selectionInfo.consoleType,
      totalAnnouncements:0,
      isEdited:true,
      userId:this.selectionInfo.rootScopeData?.currentUser?.userId?.toString(),
      name:`${this.commonUtil.translateText('Announcement')} ${datePipe.transform(Date.now(), 'MMddyyyy_H:mm')}`
    };
    
    this.hasNewItem = true;
    this.setId = defaultNewAnnouncement.id;
   
    this.announcementsList.unshift(JSON.parse(JSON.stringify(defaultNewAnnouncement)));
    this.originalAnnouncementsList.unshift(JSON.parse(JSON.stringify(defaultNewAnnouncement)));
    // show newly added item
    setTimeout(() => {
      //@ts-ignore
      $('#collapse-1').collapse('show');
    }, 100);
    this.selectionInfo.rootScopeData.isPageHasUnsavedChanges = true;
  }

  undoAll(curUpdatedAnnouncement:any,parentIdx:any){
    this.announcementsList[parentIdx] =  JSON.parse(JSON.stringify(this.originalAnnouncementsList[parentIdx]));
    this.setId = curUpdatedAnnouncement.id;
    setTimeout(val => {
      let element = document.getElementById('collapse'+curUpdatedAnnouncement.id);
      element?.classList.add('show');
    },1000)
  }

  saveAs(announcement:any,parentIdx:any){
    if(announcement.id == "-1"){
      this.hasNewItem = false;
    }
    this.showSaveAsModalDialog();
    this.saveAsAnnouncementObj = JSON.parse(JSON.stringify(announcement));
  }

  showSaveAsModalDialog() {
    this.modal.add({
      dismissible: true,
      titleUppercase: true,      
      modalSize: HaloModalSize.Medium,
      title: this.commonUtil.translateText('SAVEAS'),
      bodyTemplate: this.bodyTemplate,
      footerTemplate: this.actionTemplate
    });
    this.saveAsLabel = this.commonUtil.replaceValueAsHTMLOnTranslatedText('GENERIC.NEW.NAME', [this.commonUtil.translateText('ANNOUNCEMENT')]);
  }

  async showPreviewScreen(announcement:any){
    this.stopSlideshow = false;
    this.modal.add({
      dismissible: true,
      titleUppercase: true,      
      modalSize: HaloModalSize.Large,
      title: this.commonUtil.translateText('VIEW.ON.CONSOLE'),
      bodyTemplate: this.previewScreenbodyTemplate
    });
    this.showPreviewScreenLabel = this.commonUtil.translateText('ANNOUNCEMENT.DURATION.MESSAGE');
    this.previewScreenAnnouncementDetailsList =  JSON.parse(JSON.stringify((announcement.announcementDetailsList as announcementDetailsListObject[]).filter(val => val.title.trim() !== '' || val.message.trim() !== ''))) ;
    
    await this.timeout(1000);
    this.resetPreviewSlideShowStyles();
    let previewScreenMessages = $('.previewScreen-announcement__message');
    for(var i=0;i < previewScreenMessages.length; i++){
      let element = $(previewScreenMessages[i]);
      element.fadeIn(1000)
      .delay(2000)
      .fadeOut(1000);
      await this.timeout(4000);
      previewScreenMessages[i].style.display = 'none';
      if(i+1 === previewScreenMessages.length){
        i = -1;
      }
      if(this.stopSlideshow) break;
    }
  }

  resetPreviewSlideShowStyles(){
    (document.getElementsByClassName('previewScreen-modal')[0].parentElement as HTMLElement).style.overflow = 'unset';
    (document.getElementsByClassName('previewScreen-modal')[0].parentElement as HTMLElement).style.maxHeight = 'none';

    let previewScreenModalWidth = (document.getElementsByClassName('previewScreen-modal')[0] as HTMLElement).offsetWidth;
    let tmp = (previewScreenModalWidth - 680);
    (document.getElementsByClassName('previewScreen-announcement__container__wrapper')[0] as HTMLElement).style.top = '40px';
    (document.getElementsByClassName('previewScreen-announcement__container__wrapper')[0] as HTMLElement).style.right = tmp+'px';
    (document.getElementsByClassName('previewScreen-announcement__container__wrapper')[0] as HTMLElement).style.display = 'block';
    (document.getElementsByClassName('previewScreen-announcement__container__wrapper')[0] as HTMLElement).style.position = 'absolute';
  }

  timeout(ms:number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  onCancel() {
    this.saveAsName = '';
    this.saveAsAnnouncementObj=null;
    this.modal.close();
  }

  async onSaveAsTrigger() {
    if(this.saveAsName.trim() === ''){
      this.saveAsError = true;
    }else{
      this.saveAsError = false;
      let announcementDetails = (this.saveAsAnnouncementObj.announcementDetailsList as announcementDetailsListObject[]).filter(val => val.message || val.title);

      if(announcementDetails.length>0){
        announcementDetails.forEach((val,idx) => {
          val.displayOrder = idx+1
        })
        let payload = {};
  
        payload = {
          announcementDetailsList:announcementDetails,
          consoleType: this.saveAsAnnouncementObj.consoleType,
          duration: this.saveAsAnnouncementObj.duration,
          name: this.saveAsName,
          id: null
        }
    
        try {
          this.loader.startProcess();
          let resp:any = await this.announcementServ.postAnnouncement(payload);
          this.updateAnnouncementObjectAfterSaved(resp,'saveAs',this.saveAsAnnouncementObj.id);
          this.toast.creatToast(this.commonUtil.replaceValueAsHTMLOnTranslatedText('GENERIC.SAVED.SUCCESSFULLY', [resp.name]), EToastType.SUCCESS);
          this.selectionInfo.rootScopeData.isPageHasUnsavedChanges =  this.announcementsList.some(a => a.isEdited);

        } catch (error) {  
          console.error('API error.');
        }
        finally {
          this.loader.endProcess();
          this.onCancel();
        }
      } 
    } 
  }

  async save(curAnnouncementObj:announcementObject,parentIdx:any) {
    let announcementDetails = curAnnouncementObj.announcementDetailsList.filter(val => val.message || val.title);

    if(announcementDetails.length>0){
      announcementDetails.forEach((val,idx) => {
        val.displayOrder = idx+1
      })
      let payload:any;

      if(curAnnouncementObj.totalAnnouncements>1){
        payload = {
          announcementDetailsList:announcementDetails,
          consoleType: curAnnouncementObj.consoleType,
          duration: curAnnouncementObj.duration?curAnnouncementObj.duration:120,
          name: curAnnouncementObj.name,
        };
      }else{
        payload = {
          announcementDetailsList:announcementDetails,
          consoleType: curAnnouncementObj.consoleType,
          name: curAnnouncementObj.name,
        }
      }

      if(curAnnouncementObj.id !== '-1'){
        payload['id'] = curAnnouncementObj.id;
      }
  
      try {
        this.loader.startProcess();
        let resp:any = await this.announcementServ.postAnnouncement(payload);
        this.updateAnnouncementObjectAfterSaved(resp,'save',curAnnouncementObj.id,parentIdx);
        //If current saved item is new item , reset back 'hasNewItem' to be false.
        if(curAnnouncementObj.id === '-1'){
          this.hasNewItem = false;
        }
        this.toast.creatToast(this.commonUtil.replaceValueAsHTMLOnTranslatedText('GENERIC.SAVED.SUCCESSFULLY', [resp.name]), EToastType.SUCCESS);
        this.selectionInfo.rootScopeData.isPageHasUnsavedChanges =  this.announcementsList.some(a => a.isEdited);
      } catch (error) {  
        console.error('API error.');
      }
      finally {
        this.loader.endProcess();
      }
    } 
  }

  async publish(curAnnouncementObj:announcementObject,parentIdx:any){
    let announcementDetails = curAnnouncementObj.announcementDetailsList.filter(val => val.message || val.title);
    announcementDetails.forEach((val,idx) => {
      val.displayOrder = idx+1
    })
    var payload = {
			consoleType : curAnnouncementObj.consoleType,
			facilityIds : this.selectionInfo.facility.facilityId.split(','),
			activityIds : ["-1"],
			announcements:{
        consoleType: curAnnouncementObj.consoleType,
        duration: curAnnouncementObj.duration,
        id: curAnnouncementObj.id === '-1'?null:curAnnouncementObj.id,
        name: curAnnouncementObj.name,
        updatedAt: curAnnouncementObj.updatedAt,
        updatedAtTimeStamp: curAnnouncementObj.updatedAtTimeStamp,
        userId: curAnnouncementObj.userId,
        announcementDetailsList: announcementDetails
      }
		}

    try {
      this.loader.startProcess();
      let resp:any = await this.announcementServ.publishAnnouncement(payload);
      this.getData();
      this.toast.creatToast(this.commonUtil.replaceValueAsHTMLOnTranslatedText('GENERIC.PUBLISHED.SUCCESSFULLY', [curAnnouncementObj.name?curAnnouncementObj.name:'']), EToastType.SUCCESS);
    } catch (error) {  
      console.error('API error.');
    }
    finally {
      this.loader.endProcess();
      this.resetStatus();
    }
  }


  updateAnnouncementObjectAfterSaved(curUpdatedAnnouncement:any,source:string,selectedAnnouncementId:string,parentIdx?:any){
    let announcementData = this.announcementServ.prepareAnnouncementData({announcementsList:[curUpdatedAnnouncement]});
    if(source === 'save'){
      this.announcementsList[parentIdx] = JSON.parse(JSON.stringify(announcementData[0]));
      this.originalAnnouncementsList[parentIdx] = JSON.parse(JSON.stringify(announcementData[0]));
      this.setId = announcementData[0].id;
      setTimeout(val => {
        let element = document.getElementById('collapse'+announcementData[0].id);
        element?.classList.add('show');
      },1000)
    }else if(source === 'saveAs'){
      this.announcementsList.unshift(JSON.parse(JSON.stringify(announcementData[0])));
      this.originalAnnouncementsList.unshift(JSON.parse(JSON.stringify(announcementData[0])));
      this.setId = announcementData[0].id;
      setTimeout(val => {
        let selectedAnnouncementElement = document.getElementById('collapse'+selectedAnnouncementId);
        selectedAnnouncementElement?.classList.remove('show');
        let element = document.getElementById('collapse'+announcementData[0].id);
        element?.classList.add('show');
      },1000)
    }
  }

  checkIsNotEmptyAnnouncement(announcementDetail:any) {
		if($.trim(announcementDetail.title) != '' || $.trim(announcementDetail.message) != ''){
				return true;
		}
		return false;
	}

  inputKeyup(announcement:announcementObject){
    //check undo all and reset duration on.
    announcement.hasAnnouncementChanged = this.checkedAnnouncementChanged(announcement);
    announcement.totalAnnouncements = announcement.announcementDetailsList.filter(val => val.title.trim() !== '' || val.message.trim() !== '').length;
    this.announcementsList.filter(val => val.id ===  announcement.id).map(val => val.isEdited = announcement.hasAnnouncementChanged?announcement.hasAnnouncementChanged:false);
    this.selectionInfo.rootScopeData.isPageHasUnsavedChanges = true;
  }

  setAnnouncementDuration(announcement:any,duration:string){
    if(announcement.totalAnnouncements>1){
      announcement.duration = duration;
    }
  }

  checkedAnnouncementChanged(announcement:any){
    let status = false;
    let tmpOriginalList = this.originalAnnouncementsList.find(val => val.id === announcement.id);
    if(announcement.duration !== tmpOriginalList?.duration){
      return true;
    }
    let originalData  = ((tmpOriginalList?.announcementDetailsList) as announcementDetailsListObject[]).filter(val => val.title.trim() !== '' || val.message.trim() !== ''); 
    let selectedData = ((announcement.announcementDetailsList) as announcementDetailsListObject[]).filter(val => val.title.trim() !== '' || val.message.trim() !== '');
   
    if(originalData.length !== selectedData.length){
      status = true;
    }else{
      tmpOriginalList?.announcementDetailsList.forEach(originalDetail => {
        let currentSelectedAnnouncement : announcementDetailsListObject[] = announcement.announcementDetailsList;
        if(originalDetail.title !== currentSelectedAnnouncement.find(val => val.id === originalDetail.id)?.title){
          status = true;
        }
        if(originalDetail.message !== currentSelectedAnnouncement.find(val => val.id === originalDetail.id)?.message){
          status = true;
        }
      });
    }
    return status;
  }

  checkedAnnouncementDisplayOrderChanged(announcementId:any){
    let originalAnnnouncementLists = this.originalAnnouncementsList.find(val => val.id === announcementId);
    let currentedSelectedAnnouncementLists = this.announcementsList.find(val => val.id === announcementId);
    let originalAnnouncementDisplayedOrder = originalAnnnouncementLists?.announcementDetailsList.map((item) => {
      return item.id
    }).join(",");
    let currentAnnouncementDisplayedOrder = currentedSelectedAnnouncementLists?.announcementDetailsList.map((item) => {
      return item.id
    }).join(",");
    if(originalAnnouncementDisplayedOrder !== currentAnnouncementDisplayedOrder){
      return true;
    }
    return false;
  }

  onKeydown(event:any){
    if(event.key === 'Enter' || event.keyCode === 13){
      event.preventDefault();
    }
  }

  private onSelectionChange(selectionInfo: SelectionInfo) {
    setTimeout(() => {
      this.selectionInfo = selectionInfo;
      if(this.selectionInfo.facility.summary.facilityRights.announcement === 'true'){
        this.getData();
        this.resetStatus();
        this.setId = '';
      } else if(this.selectionInfo.facility.summary.facilityRights.productSetting === 'true'){
        this.router.navigate(['/equipmentSettings/setting']);
      } else{
        this.commonUtil.redirectToAvailablePage();
      } 
    });
  }
}
